export const useApiBase = () => {
  const config = useRuntimeConfig()
  const base = process.server
    ? (config.apiBaseServer || "")
    : (config.public?.apiBase || "")
  return (base || "").replace(/\/$/, "")
}
